module.exports = __webpack_public_path__ + "static/imagarket-d29b380eb31eb2af37f7e58e089c10dc.png";